/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AssetImportResultDto = {
    message?: string;
    status?: AssetImportResultDto.status;
    uri?: string;
};

export namespace AssetImportResultDto {

    export enum status {
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
    }


}
